import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

const ErrorPage = () => {
  const [currentSeconds, setCurrentSeconds] = useState(3);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSeconds((prevSeconds) => {
        if (prevSeconds > 1) {
          return prevSeconds - 1;
        } else {
          clearInterval(interval);
          window.location.href = "/";
          return 0;
        }
      });
    }, 1000);

    // 清理函数
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      <Header />
      <div className="error-container">
        <div className="error-content">
          <p className="error-message">
            Game Load Error, The System Will Go Home Page in {currentSeconds}{" "}
            Seconds
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ErrorPage;
